module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "acknowledgments",
    attrs: {
      "id": "acknowledgments_1"
    }
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "href": "#/NoControl_toc#ackn_1"
    }
  }, [_c('strong', [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("I have a lot of people to thank for helping me make this book so much better than it would have been otherwise: my agent, Nephele Tempest, my editor, Michele Bidelspach, and my beta readers, Dyann, Julie, Karen, Michelle, Sara, Sherry and Tonia. Your efforts, input, and encouragement are an invaluable help to me, and I can’t thank you enough.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b9b460","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoControl_ackn_1.vue
// module id = 75
// module chunks = 0